import { apiSlice } from './apiSlice'

export interface JudgeAssignment {
  id: string
  judge_id: string
  case_id: string
  team_ids: string[]
  notes?: string | null
  created_at?: string
  created_by?: string | null
}

export interface JudgeAssignmentCreate {
  judge_id: string
  case_id: string
  team_ids: string[]
  notes?: string | null
}

export const judgeAssignmentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getJudgeAssignments: builder.query<
      JudgeAssignment[],
      { judge_id?: string; case_id?: string } | void
    >({
      query: (params) => ({
        url: '/judge-assignments/list',
        params: params || {},
      }),
      providesTags: ['JudgeAssignment'],
    }),
    createJudgeAssignment: builder.mutation<JudgeAssignment, JudgeAssignmentCreate>({
      query: (body) => ({
        url: '/judge-assignments/create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['JudgeAssignment', 'Case'],
    }),
    deleteJudgeAssignment: builder.mutation<{ message: string }, string>({
      query: (id) => ({
        url: `/judge-assignments/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['JudgeAssignment', 'Case'],
    }),
  }),
})

export const {
  useGetJudgeAssignmentsQuery,
  useCreateJudgeAssignmentMutation,
  useDeleteJudgeAssignmentMutation,
} = judgeAssignmentsApi
